import { render, staticRenderFns } from "./DatabaseItems.vue?vue&type=template&id=16ce7c33&"
import script from "./DatabaseItems.vue?vue&type=script&lang=js&"
export * from "./DatabaseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports